'use client';

import { type ReactNode, useEffect, useState, type ReactElement } from 'react';
import { useLoading } from './loading-context.provider';
import { LoadingSpinner } from '../ui/loading-spinner';

const loading = 2500;

export default function LoadingProvider({
  children,
}: Readonly<{ readonly children: ReactNode }>): ReactElement {
  const { loaded, setLoaded } = useLoading();
  const [show, setShow] = useState(!loaded);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        setShow(false);
        setLoaded(true);
      }, loading);
      const interval = setInterval(() => {
        setProgress((prev) => Math.min(prev + 1, 100));
      }, loading / 100);
      return () => {
        clearTimeout(timer);
        clearInterval(interval);
      };
    }
  }, [show]);

  return (
    <div className="relative w-full h-full">
      {show && (
        <div className="fixed w-screen h-screen inset-0 flex flex-col gap-5 items-center justify-center bg-background z-50 p-4">
          <LoadingSpinner className="w-6 h-6" />
          <p className="text-base text-center font-normal opacity-90">
            Decentralized AI marketplace
          </p>
          <div className="w-full flex flex-col gap-1.5 items-center justify-center">
            <div className="w-11/12 max-w-64 h-2 bg-secondary rounded-full overflow-hidden">
              <div
                className="h-full bg-primary transition-all duration-75"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
